import { observable } from 'mobx';
import { createObservableInstance } from '../../helpers';
import FirebaseRefListener from './base/FirebaseRefListener';

class FirebaseCollection extends FirebaseRefListener {
  constructor(root, { ref, ItemClass }) {
    super(root, { ref });

    this.ItemClass = ItemClass;
  }

  data = [];

  handleSnapshot(snapshot) {
    super.handleSnapshot(snapshot);
    this.snapshot = snapshot;
    // console.log('HANDLE SNAPSHOT', snapshot);
    snapshot.docChanges().forEach(({ type, doc, oldIndex, newIndex }) => {
      // console.log(type, oldIndex, newIndex, doc.data().itemUid);
      if (type === 'added') {
        this.data.splice(
          newIndex,
          0,
          createObservableInstance(this.ItemClass, this, {
            snapshot: doc,
          })
        );
      } else if (type === 'modified') {
        if (newIndex !== oldIndex) {
          this.data.splice(newIndex, 0, this.data.splice(oldIndex, 1)[0]);
        }
        this.data[newIndex].handleSnapshot(doc);
      } else if (type === 'removed') {
        const removed = this.data[oldIndex];
        this.data.splice(oldIndex, 1);
        removed.destroy();
      }
    });
    // this.data.map((iDoc) => iDoc.destroy());
    // this.data =
    //   this.snapshot?.docs.map((doc) =>
    //     createObservableInstance(this.ItemClass, this, { snapshot: doc })
    //   ) || [];
    //
    // console.log(this.data[0]?.data);
  }
}

FirebaseCollection.annotations = {
  ...FirebaseRefListener.annotations,
  // data: observable.array([]),
  data: observable.shallow,
};

export default FirebaseCollection;
